<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.edit_mosque") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mosque_name_ar')"
            v-model.trim="data.name_ar"
            :maxlength="100"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mosque_name_en')"
            v-model.trim="data.name_en"
            :maxlength="100"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: City Input -->
          <base-select-input
            col="6"
            :optionsList="cities"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model="data.city_id"
            required
          />
          <!-- End:: City Input -->

          <!-- Start:: Address Title Input -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address_title')"
            v-model.trim="data.address_title"
            :maxlength="500"
            required
          /> -->
          <!-- End:: Address Title Input -->

          <!-- Start:: Address Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.address')"
            v-model.trim="data.address"
            :maxlength="500"
            required
          />
          <!-- End:: Address Input -->

          <!-- Start:: Location Inputs -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.latitude')"
            v-model.trim="data.lat"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.longitude')"
            v-model.trim="data.lng"
            required
          />
          <!-- End:: Location Inputs -->

          <!-- Start:: Map Component -->
          <div class="col-12 my-3">
            <ChangableMapComponent
              :lat="data.lat ? parseFloat(data.lat) : 24.7136"
              :lng="data.lng ? parseFloat(data.lng) : 46.6753"
              @update:lat="data.lat = $event"
              @update:lng="data.lng = $event"
            />
          </div>
          <!-- End:: Map Component -->

          <!-- Start:: Status Dropdown -->
          <base-select-input
            col="12"
            :optionsList="statusOptions"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model="data.is_active"
            required
          />
          <!-- End:: Status Dropdown -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import ChangableMapComponent from "@/components/general/ChangableMapComponent";

export default {
  name: "EditMosque",
  components: {
    ChangableMapComponent,
  },
  data() {
    return {
      isWaitingRequest: false,
      data: {
        name_ar: "",
        name_en: "",
        city_id: null,
        address: "",
        address_title: "",
        lat: null,
        lng: null,
        is_active: null,
      },
      cities: [],
      statusOptions: [
        { id: 1, name: this.$t("STATUS.active"), value: 1 },
        { id: 0, name: this.$t("STATUS.notActive"), value: 0 },
      ],
    };
  },
  methods: {
    // Start:: Get Cities
    async getCities() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "cities",
          params: {
            is_active: 1,
            limit: 0,
            page: 0,
          },
        });
        this.cities = res.data.data.data.map((city) => ({
          id: city.id,
          name: city.name,
          value: city.id,
        }));
      } catch (error) {
        console.log(error.response?.data?.message);
      }
    },
    // End:: Get Cities

    // Start:: Get Mosque Data
    async getMosqueData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `mosques/${this.$route.params.id}`,
        });
        const mosqueData = res.data.data.mosque;

        this.data.name_ar = mosqueData?.name_ar;
        this.data.name_en = mosqueData?.name_en;
        this.data.address = mosqueData?.address;
        this.data.address_title = mosqueData?.address_title;
        this.data.lat = mosqueData?.lat;
        this.data.lng = mosqueData?.lng;

        // Set city_id
        if (mosqueData?.city_id) {
          this.data.city_id = this.cities.find(
            (city) => city.value === mosqueData.city_id
          );
        }

        // Set is_active status
        const isActive = mosqueData?.is_active;
        this.data.is_active = this.statusOptions.find(
          (option) => option.value === (isActive ? 1 : 0)
        );
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Get Mosque Data

    // Start:: validate Form Inputs
    validateFormInputs() {
      // Name validation
      if (!this.data.name_ar || this.data.name_ar.length < 2) {
        this.$message.error(this.$t("VALIDATION.name_ar_min_length"));
        return;
      }
      if (this.data.name_ar.length > 100) {
        this.$message.error(this.$t("VALIDATION.name_ar_max_length"));
        return;
      }
      if (!this.data.name_en || this.data.name_en.length < 2) {
        this.$message.error(this.$t("VALIDATION.name_en_min_length"));
        return;
      }
      if (this.data.name_en.length > 100) {
        this.$message.error(this.$t("VALIDATION.name_en_max_length"));
        return;
      }

      // City validation
      if (!this.data.city_id) {
        this.$message.error(this.$t("VALIDATION.city"));
        return;
      }

      // Address validation
      if (!this.data.address || this.data.address.length < 2) {
        this.$message.error(this.$t("VALIDATION.address_min_length"));
        return;
      }
      if (this.data.address.length > 500) {
        this.$message.error(this.$t("VALIDATION.address_max_length"));
        return;
      }

      // Address title validation
      // if (!this.data.address_title) {
      //   this.$message.error(this.$t("VALIDATION.address_title"));
      //   return;
      // }

      // Location validation
      if (!this.data.lat) {
        this.$message.error(this.$t("VALIDATION.latitude"));
        return;
      }
      if (!this.data.lng) {
        this.$message.error(this.$t("VALIDATION.longitude"));
        return;
      }

      // Status validation
      if (this.data.is_active === null || this.data.is_active === undefined) {
        this.$message.error(this.$t("VALIDATION.status"));
        return;
      }

      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("_method", "PUT");

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.city_id) {
        REQUEST_DATA.append(
          "city_id",
          this.data.city_id?.value || this.data.city_id
        );
      }
      if (this.data.address) {
        REQUEST_DATA.append("address", this.data.address);
        REQUEST_DATA.append("address_title", this.data.address);
      }
      // if (this.data.address_title) {
      // }
      if (this.data.lat) {
        REQUEST_DATA.append("lat", this.data.lat);
      }
      if (this.data.lng) {
        REQUEST_DATA.append("lng", this.data.lng);
      }
      if (this.data.is_active !== null && this.data.is_active !== undefined) {
        REQUEST_DATA.append(
          "is_active",
          this.data.is_active?.value ?? this.data.is_active
        );
      }

      try {
        await this.$axios({
          method: "POST",
          url: `mosques/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/mosques/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    await this.getCities();
    await this.getMosqueData();
  },
};
</script>
